<template>
  <div
    v-loading="loading"
    element-loading-text="正在分析，请稍后..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    class="d-pan"
  >
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
      <el-form-item label="起点" prop="start">
        <el-input placeholder="请在图上选点，左键结束" v-model="ruleForm.start">
          <el-button
            @click="selectedMode = 'start'"
            slot="append"
            icon="el-icon-edit"
          ></el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="终点" prop="end">
        <el-input placeholder="请在图上选点，左键结束" v-model="ruleForm.end">
          <el-button
            @click="selectedMode = 'end'"
            slot="append"
            icon="el-icon-edit"
          ></el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="机型" prop="modelUrl">
        <el-select @change="modelChange" v-model="formSet.model">
          <el-option
            :key="item.label"
            v-for="item in models"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="飞行日期">
        <el-date-picker
          class="flightDateClass"
          v-model="flightDate"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="setFlightDateTime"
        >
        </el-date-picker>
      </el-form-item>
      <!-- <el-form-item label="飞行倍率">
        <el-input-number
          :step="0.5"
          v-model="formSet.scale"
          controls-position="right"
          @change="handleChange"
          :min="0"
        ></el-input-number>
      </el-form-item> -->
      <el-form-item label="飞行视角">
        <el-select @change="changeView" v-model="formSet.view">
          <el-option
            v-for="item in views"
            :label="item.label"
            :value="item.value"
            :key="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div class="item-chaxun">
      <el-button
        :disabled="disabled_submitGrid"
        type="primary"
        @click="submitGrid('ruleForm')"
        >生成网格</el-button
      >
      <el-button
        :disabled="disabled_hideGrid"
        type="primary"
        @click="hideGrid('ruleForm')"
        >{{ textContent }}</el-button
      >
      <!-- <el-button type="primary" @click="clearGrid('ruleForm')">清除网格</el-button> -->
    </div>

    <div class="item-chaxun">
      <el-button
        :disabled="disabled_submitFly"
        type="primary"
        @click="submitFly('ruleForm')"
        >航线规划</el-button
      >
      <!-- <el-button type="primary" @click="clearFly('ruleForm')">清除航线</el-button> -->
      <el-checkbox
        :disabled="disabled_submitFly"
        @change="changeGrid"
        style="margin: 0 0 0 10px"
        v-model="checkedGrid"
        >只显示航线网格</el-checkbox
      >
    </div>

    <div class="item-chaxun">
      <el-button
        :disabled="disabled_startFly"
        type="primary"
        @click="startFly('ruleForm')"
        >飞行模拟</el-button
      >
      <el-button
        :disabled="disabled_clearFlyData"
        type="primary"
        @click="clearFlyData('ruleForm')"
        >清除分析结果</el-button
      >
    </div>
    <div class="item-chaxun">
      <div class="path-legend">
        <div style="display: flex; align-items: center; margin: 5px 0">
          <div
            style="width: 15px; height: 15px; background-color: red; margin-right: 5px"
          ></div>
          <span>不可通行</span>
        </div>
        <div style="display: flex; align-items: center; margin: 5px 0">
          <div
            style="width: 15px; height: 15px; background-color: green; margin-right: 5px"
          ></div>
          <span>可通行</span>
        </div>
        <div style="display: flex; align-items: center; margin: 5px 0">
          <div
            style="width: 15px; height: 15px; background-color: yellow; margin-right: 5px"
          ></div>
          <span>规划路径</span>
        </div>
        <div style="display: flex; align-items: center; margin: 5px 0">
          <div
            style="width: 15px; height: 15px; background-color: blue; margin-right: 5px"
          ></div>
          <span>起点/终点</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var point_Start = undefined;
var point_End = undefined;
var entityCache = [];
let animationUti = undefined;
let raisedPositions = [];
let flylineEntityCache = undefined;
import { drivingSearch, addressSearch } from "../../utils/gaodeAPI";
import PathAnimation from "@/utils/cesiumBD/animation/PathAnimation";
import { gcj2wgs } from "@/utils/cesiumBD/utils/CoordinateUtil.js";
import { createLine } from "@/api/line/index.js";
import modelsCom from "./models.vue";
/*********************/
let tileset;
export default {
  props: ["subData"],
  data() {
    return {
      disabled_submitGrid: false,
      disabled_hideGrid: true,
      disabled_submitFly: true,
      disabled_startFly: true,
      disabled_clearFlyData: true,
      checkedGrid: false,
      textContent: "隐藏网格",
      gridVisible: true,
      flightDate: "",
      loading: false,
      ruleForm: {
        title: "人员运输",
        start: "",
        end: "",
        height: 0,
        beginTime: undefined,
        endTime: undefined,
        modelUrl: undefined,
      },
      formSet: {
        model: "", //模型的地址
        surface: false,
        animation: "无",
        view: "无",
        cycle: false,
        height: 0,
        addHeight: 0,
        speed: 80,
        scale: 1,
      },
      rules: {
        title: [{ required: true, message: "请输入航线名称", trigger: "blur" }],
        height: [{ required: true, message: "请输入飞行高度", trigger: "change" }],
        start: [{ required: true, message: "请选择起点", trigger: "change" }],
        end: [{ required: true, message: "请选择终点", trigger: "change" }],
        modelUrl: [{ required: true, message: "请选择机型", trigger: "blur" }],
      },
      selectedMode: "",
      titles: [
        {
          label: "人员运输",
          value: "人员运输",
        },
        {
          label: "货物运输",
          value: "货物运输",
        },
        {
          label: "其他",
          value: "其他",
        },
      ],
      models: [
        {
          label: "无人机",
          value: "无人机",
        },
        {
          label: "直升机",
          value: "直升机",
        },
        {
          label: "通航机",
          value: "通航机",
        },
      ],
      views: [
        {
          label: "无",
          value: "无",
        },
        {
          label: "跟随视角",
          value: "gs",
        },
        {
          label: "第一视角",
          value: "dy",
        },
        {
          label: "上帝视角",
          value: "sd",
        },
      ],
    };
  },
  created() {},
  async mounted() {
    this.$bus.$on("setModelUrl", (model) => {
      this.ruleForm.modelUrl = model;
    });

    tileset = await CesiumSetup.initPhotorealistic3DTiles(viewer);
    CesiumSetup.setupCamera(viewer);

    var $this = this;
    var handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
    handler.setInputAction(function (evt) {
      if ($this.selectedMode == "start") {
        //单机开始绘制
        var cartesian = $this.getCatesian3FromPX(evt.position);
        $this.ruleForm.start = cartesian;
        $this.selectedMode = "";
      }
      if ($this.selectedMode == "end") {
        //单机开始绘制
        var cartesian = $this.getCatesian3FromPX(evt.position);
        $this.ruleForm.end = cartesian;
        $this.selectedMode = "";
      }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
    handler.setInputAction(function (evt) {
      if ($this.selectedMode == "start") {
        var cartesian = $this.getCatesian3FromPX(evt.endPosition);
        $this.ruleForm.start = cartesian;
      }
      if ($this.selectedMode == "end") {
        var cartesian = $this.getCatesian3FromPX(evt.endPosition);
        $this.ruleForm.end = cartesian;
      }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
  },
  beforeDestroy() {
    this.selectedMode = "";
    this.clearFlyData();

    if (tileset) {
      viewer.scene.primitives.remove(tileset);
      tileset = null;
    }
  },
  methods: {
    modelChange() {
      //return
      var ins = this.$dialog.getDialog("机型库");
      if (ins) {
        return;
      }
      this.$dialog.open({
        id: "机型库",
        title: "机型库",
        theme: "feature-dialog",
        shade: true,
        area: {
          height: "750px",
          width: "680px",
        },
        content: {
          type: "vue",
          subCom: modelsCom,
          subData: this.formSet.model,
        },
      });
    },
    setFlightDateTime(val) {
      if (val) {
        this.ruleForm.beginTime = val[0];
        this.ruleForm.endTime = val[1];
      } else {
        this.ruleForm.beginTime = undefined;
        this.ruleForm.endTime = undefined;
      }
    },
    changeView(val) {
      animationUti && animationUti.setCameraType(val);
    },
    handleChange(val) {
      animationUti && animationUti.setMultiplier(val);
    },
    flyTo(lon, lat, alt) {
      alt = alt || 0;
      viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(lon, lat, alt + 10000.0),
      });
    },
    handleSelectStart(item) {
      console.log(item);
      let $this = this;
      this.origin = item.location;
      let zb84 = gcj2wgs(item.location.split(","));
      let cartesian = Cesium.Cartesian3.fromDegrees(zb84[0], zb84[1]);
      if (!point_Start) {
        point_Start = $this.createPoint(cartesian, "起点");
      } else {
        point_Start.position.setValue(cartesian);
      }

      this.flyTo(zb84[0], zb84[1]);
      this.origin_zb84 = zb84;
    },
    handleSelectEnd(item) {
      console.log(item);
      let $this = this;
      this.destination = item.location;
      let zb84 = gcj2wgs(item.location.split(","));
      let cartesian = Cesium.Cartesian3.fromDegrees(zb84[0], zb84[1]);
      if (!point_End) {
        point_End = $this.createPoint(cartesian, "终点");
      } else {
        point_End.position.setValue(cartesian);
      }

      this.flyTo(zb84[0], zb84[1]);
      this.destination_zb84 = zb84;
    },
    querySearchAsync(queryString, cb) {
      if (!queryString) {
        return;
      }
      var results = []; //结果值
      addressSearch(
        {
          address: queryString,
        },
        (res) => {
          if (res.status == 1) {
            let geocodes = res.geocodes;
            results = geocodes.map((g) => {
              g.value = g.formatted_address;
              return g;
            });
            cb(results); //回调
          }
        }
      );
    },
    submitAdd(formName) {
      if (!raisedPositions || raisedPositions.length <= 1) {
        this.$message({
          message: "暂无数据，请先查询航线数据！",
          type: "warning",
        });
        return;
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          let lineObj = {
            title: this.ruleForm.title,
            formData: {
              timeStr: this.formatCurrentTime(),
              start: this.ruleForm.start,
              startLon: this.origin_zb84[0],
              startLat: this.origin_zb84[1],
              end: this.ruleForm.end,
              endLon: this.destination_zb84[0],
              endLat: this.destination_zb84[1],
              height: this.ruleForm.height,
              raisedPositions: raisedPositions,
            },
          };
          this.loading = true;
          createLine({
            line: JSON.stringify(lineObj),
          })
            .then((res) => {
              this.$message({
                message: "线路创建成功",
                type: "success",
              });
              this.loading = false;
              this.$bus.$emit("line-list-refresh");
              this.$parent.close(); //关闭
            })
            .catch((e) => {
              this.loading = false;
              console.error(e);
            });
        } else {
          return false;
        }
      });
    },
    formatCurrentTime() {
      const now = new Date(); // 获取当前时间

      const year = now.getFullYear(); // 获取年份
      const month = String(now.getMonth() + 1).padStart(2, "0"); // 获取月份，并补零
      const day = String(now.getDate()).padStart(2, "0"); // 获取日期，并补零
      const hours = String(now.getHours()).padStart(2, "0"); // 获取小时，并补零
      const minutes = String(now.getMinutes()).padStart(2, "0"); // 获取分钟，并补零
      const seconds = String(now.getSeconds()).padStart(2, "0"); // 获取秒钟，并补零

      // 格式化输出
      const formattedTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      return formattedTime;
    },
    async submitFly() {
      if (!this.pathPlanning || !this.pathPlanning.isEnabled) {
        console.warn("路径规划功能未启用或占用网格未生成");
        return;
      }
      this.loading = true;
      try {
        this.pathPlanning.setWaypoints(this.waypoints);
        // 启用抛物线路径模式
        this.pathPlanning.setParabolicPathEnabled(true);
        await this.pathPlanning.planPath();
        this.loading = false;
        this.disabled_startFly = false;
        this.disabled_clearFlyData = false;
        //this.disabled_submitFly = true;
      } catch (error) {
        console.error("路径规划失败:", error);
      }
    },
    clearFly() {
      if (this.pathPlanning) {
        this.pathPlanning.clearPath();
      }
    },
    changeGrid(checked) {
      if (this.pathPlanning) {
        this.pathPlanning.setShowOnlyPath(checked);
      }
    },
    startFly(formName) {
      // 获取路径航点
      const pathWaypoints = this.getPathWaypoints();
      if (!pathWaypoints || pathWaypoints.length < 2) {
        alert("路径航点不足，无法开始飞行");
        return;
      }

      console.log("pathWaypoints", pathWaypoints);

      this.$refs[formName].validate((valid) => {
        if (valid) {
          animationUti && animationUti.stop();
          var positions = pathWaypoints.map((p) => p.position);
          var entity = this.createGLBElement();
          viewer.entities.add(entity);
          var animation = new PathAnimation({
            entity: entity,
            positions: positions,
            speed: this.formSet.speed,
            multiple: this.formSet.scale,
            height: this.ruleForm.height,
            addHeight: this.formSet.addHeight,
            cameraType: this.formSet.view,
            shadingType: this.formSet.animation,
            surface: this.formSet.surface,
            cycle: this.formSet.cycle,
          });

          animation.start();
          animationUti = animation;

          var line = {
            polyline: {
              show: true,
              clampToGround: false,
              positions: positions,
              width: 4,
              material: Cesium.Color.GREEN,
            },
          };
          var line_enty = viewer.entities.add(line);
          viewer.zoomTo(line_enty);
          entityCache.push(line_enty);
        }
      });
    },
    clearFlyData() {
      this.clear();
      animationUti && animationUti.stop();
      FlightPath.clearFlightRoute(viewer);
      if (this.pathPlanning) {
        this.pathPlanning.clearPath();
        this.pathPlanning = null;
      }
      if (this.occupancyGrid) {
        this.occupancyGrid.clearGrid();
        this.occupancyGrid = null;
      }
      this.checkedGrid = false;
      this.disabled_submitGrid = false;
      this.disabled_hideGrid = true;
      this.disabled_submitFly = true;
      this.disabled_startFly = true;
      this.disabled_clearFlyData = true;
      this.gridVisible = true;
    },

    // ================================
    // 获取路径航点 - 从路径规划模块获取路径网格的世界坐标
    // ================================
    getPathWaypoints() {
      if (
        !this.pathPlanning ||
        !this.pathPlanning.pathEntities ||
        this.pathPlanning.pathEntities.length === 0
      ) {
        console.warn("没有可用的路径数据");
        return [];
      }

      console.log("开始从路径网格生成飞行航点...");

      // 从路径实体中提取位置信息，按照路径步骤排序
      const pathWaypoints = [];
      const sortedPathEntities = this.pathPlanning.pathEntities
      // const sortedPathEntities = this.pathPlanning.pathEntities
      //   .filter((entity) => entity.properties && entity.properties.pathStep !== undefined)
      //   .sort((a, b) => {
      //     const stepA = a.properties.pathStep.getValue();
      //     const stepB = b.properties.pathStep.getValue();
      //     return stepA - stepB;
      //   });

      for (const entity of sortedPathEntities) {
        try {
          const position = entity.position.getValue(window.viewer.clock.currentTime);
          const pointType = entity.properties.pointType
            ? entity.properties.pointType.getValue()
            : "路径";

          // 为每个路径点创建航点对象
          const waypoint = {
            position: position,
            height: Cesium.Cartographic.fromCartesian(position).height,
            name: entity.name || `路径点${pathWaypoints.length + 1}`,
            type: pointType,
          };

          pathWaypoints.push(waypoint);
        } catch (error) {
          console.warn("处理路径实体时出错:", error);
        }
      }

      console.log(`成功生成${pathWaypoints.length}个路径航点`);
      console.log("路径航点类型分布:", pathWaypoints.map((wp) => wp.type).join(" -> "));

      return pathWaypoints;
    },
    // ================================
    // 更新网格信息并启用路径规划
    // ================================
    updateGridInfo() {
      const totalGrids = this.occupancyGrid.gridEntities.length;
      const occupiedGrids = this.occupancyGrid.getOccupiedGridCount();
      const freeGrids = totalGrids - occupiedGrids;
      // const occupancyRate = totalGrids > 0 ? ((occupiedGrids / totalGrids) * 100).toFixed(1) : 0;

      // document.getElementById('totalGrids').textContent = totalGrids;
      // document.getElementById('occupiedGrids').textContent = occupiedGrids;
      // document.getElementById('freeGrids').textContent = freeGrids;
      // document.getElementById('occupancyRate').textContent = occupancyRate + '%';

      // 网格生成完成后，启用路径规划功能
      if (this.pathPlanning && totalGrids > 0) {
        this.pathPlanning.setEnabled(true);
        // const planPathBtn = document.getElementById('planPathBtn');
        // if (planPathBtn) {
        //   planPathBtn.disabled = false;
        // }
        console.log("路径规划功能已启用");
      }
    },
    //构建glb模型
    createGLBElement() {
      var uri = this.ruleForm.modelUrl.style.url; //this.formSet.model == "无" ? "data/mx/dajiang.gltf" : this.formSet.model;
      var scale = this.ruleForm.modelUrl.style.scale; // this.formSet.model == "无" ? 0 : 0.2;
      var minimumPixelSize = this.formSet.model == "无" ? 0.0 : 80;
      var glb = {
        model: {
          show: true,
          uri: uri, //模型的地址
          scale: scale, //modelScale, //模型缩放比例
          minimumPixelSize: modelMinimumPixelSize, // 60,
          maximumScale: 20000, // 模型的最大比例尺大小。 minimumPixelSize的上限
          incrementallyLoadTextures: true, // 加载模型后纹理是否可以继续流入
          runAnimations: true, // 是否应启动模型中指定的glTF动画
          clampAnimations: true, // 指定glTF动画是否应在没有关键帧的持续时间内保持最后一个姿势
          shadows: Cesium.ShadowMode.ENABLED,
          heightReference: Cesium.HeightReference.NONE, //设置模型贴地,
        },
        // path: {
        //   resolution: 100000,
        //   material: new Cesium.PolylineGlowMaterialProperty({
        //     glowPower: 0.1,
        //     color: Cesium.Color.YELLOW,
        //   }),
        //   width: 10,
        // },
      };
      return new Cesium.Entity(glb);
    },
    getCatesian3FromPX(px) {
      var $this = this;
      var cartesian = viewer.scene.pickPosition(px);
      // var cartesian;
      // var ray = viewer.camera.getPickRay(px);
      //cartesian = viewer.scene.globe.pick(ray, viewer.scene);
      if (cartesian) {
        if ($this.selectedMode == "start") {
          if (!point_Start) {
            point_Start = $this.createPoint(cartesian, "起点");
          } else {
            point_Start.position.setValue(cartesian);
          }
        }
        if ($this.selectedMode == "end") {
          if (!point_End) {
            point_End = $this.createPoint(cartesian, "终点");
          } else {
            point_End.position.setValue(cartesian);
          }
        }

        var position = Cesium.Cartographic.fromCartesian(cartesian); //new this.Cesium.Cartographic(-1.31968, 0.698874);
        var longitudeString = Cesium.Math.toDegrees(position.longitude);
        var latitudeString = Cesium.Math.toDegrees(position.latitude);
        return [longitudeString, latitudeString].toString();
      }

      return [].toString();
    },
    createPoint(cartesian, text) {
      var point = viewer.entities.add({
        position: cartesian,
        point: {
          pixelSize: 10,
          color: Cesium.Color.YELLOW,
          //heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        },
        label: {
          text: text,
          font: "18px sans-serif",
          style: Cesium.LabelStyle.FILL,
          outlineWidth: 1,
          fillColor: Cesium.Color.WHITE,
          showBackground: true,
          backgroundColor: Cesium.Color.ORANGE.withAlpha(1),
          horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
          // pixelOffset: new Cesium.Cartesian2(5.0, -20.0),
          disableDepthTestDistance: Number.POSITIVE_INFINITY, // 确保标签不被模型遮挡
        },
      });
      entityCache.push(point);
      return point;
    },
    async submitForm(formName) {
      let startArr = this.ruleForm.start.split(",");
      let endArr = this.ruleForm.end.split(",");

      FlightPath.setStart(startArr);
      FlightPath.setEnd(endArr);
      this.waypoints = await FlightPath.createFlightPath(viewer);
      let flightPath = FlightPath.createFlightRoute(viewer, this.waypoints);
    },

    async submitGrid(formName) {
      if (!this.ruleForm.start || !this.ruleForm.end) {
        this.$message({
          message: "请先在地图上选择起点和终点！",
          type: "warning",
        });
        return;
      }
      this.loading = true;
      await this.submitForm();
      // 初始化占用网格 - 使用自定义配置
      const gridConfig = {
        // 网格尺寸配置
        gridSize: 25,
        gridWidth: 25,
        gridHeight: 25,
        gridDepth: 25,

        // 区域扩展配置（确保4层网格生成）
        heightExtension: 45, // 向上向下各扩展120米，确保4层网格（总高度240米，4×50=200米，留有余量）
        widthExtension: 50, // 水平方向扩展100米

        // 颜色配置
        occupiedColor: Cesium.Color.RED.withAlpha(0.7),
        freeColor: Cesium.Color.GREEN.withAlpha(0.3),
        occupiedOutlineColor: Cesium.Color.DARKRED,
        freeOutlineColor: Cesium.Color.DARKGREEN,
        outlineWidth: 1,

        // 性能配置
        maxGridCount: 10000,
        enableBatching: true,

        // 显示配置
        showOccupiedOnly: false,
        showFreeOnly: false,
        enableLogging: true,
      };

      this.occupancyGrid = new OccupancyGrid(viewer, gridConfig);
      // 初始化航线瓦片模块
      this.flightPathTiles = new FlightPathTiles(viewer);
      if (tileset) {
        this.flightPathTiles.setTileset(tileset);
        this.flightPathTiles.setWaypoints(this.waypoints);
      }

      // 初始化路径规划模块
      this.pathPlanning = new PathPlanning(viewer, this.occupancyGrid);

      if (!this.occupancyGrid) {
        console.warn("占用网格模块未初始化");
        return;
      }
      try {
        console.log("生成占用网格，基于网格范围内的所有叶子瓦片");
        // 生成占用网格，不依赖航线瓦片数据
        await this.occupancyGrid.generateOccupancyGridWithTiles(this.waypoints);
        this.updateGridInfo();
        this.loading = false;
        this.disabled_hideGrid = false;
        this.disabled_submitFly = false;
        this.disabled_submitGrid = true;
        this.disabled_clearFlyData = false;
      } catch (error) {
        console.error("生成网格失败:", error);
      }
    },
    async hideGrid() {
      this.gridVisible = !this.gridVisible;
      this.occupancyGrid.toggleGridVisibility(this.gridVisible);
      this.textContent = this.gridVisible ? "隐藏网格" : "显示网格";
    },
    async clearGrid() {
      if (this.pathPlanning) {
        this.pathPlanning.clearPath();
        // 清除路径后禁用飞行按钮
        // this.disableFlightControls();
        this.updateGridInfo();
      }
    },
    drawLine(steps) {
      var lin_arr = [];
      steps.forEach((step) => {
        var arr = step.polyline.split(";");
        lin_arr = lin_arr.concat(arr.map((p) => p.split(",")));
      });

      var car3Arr = [];
      lin_arr.forEach((coor) => {
        let zb84 = gcj2wgs([coor[0], coor[1]]);
        car3Arr.push(
          Cesium.Cartesian3.fromDegrees(zb84[0], zb84[1], this.ruleForm.height)
        );
      });
      console.log(car3Arr);
      var line = {
        polyline: {
          show: true,
          clampToGround: false,
          positions: car3Arr,
          width: 4,
          material: Cesium.Color.LIMEGREEN,
        },
      };
      var line_enty = viewer.entities.add(line);
      viewer.zoomTo(line_enty);
      entityCache.push(line_enty);

      raisedPositions = car3Arr;
      flylineEntityCache = line_enty;
    },
    addCar(car3Arr) {
      var car_4 = viewer.entities.add({
        position: car3Arr[0],
        billboard: {
          image: "data/img/marker/mark-blue.png",
          scale: 0.5,
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        },
        label: {
          text: "救援物资车辆",
          font: "14px sans-serif",
          pixelOffset: new Cesium.Cartesian2(0.0, -60.0),
          fillColor: Cesium.Color.YELLOW,
          outlineColor: Cesium.Color.YELLOW,
          outlineWidth: 2,
          style: Cesium.LabelStyle.FILL_AND_OUTLINE,
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        },
      });
      var property_4_car = new Cesium.SampledPositionProperty();
      var time_4_car = 1; //移动的时长 ，秒
      var tempTime_4_car;
      tempTime_4_car = viewer.clock.currentTime; //飞行开始时间
      viewer.clock.currentTime = viewer.clock.startTime;
      viewer.clock.clockRange = Cesium.ClockRange.LOOP_STOP;
      viewer.clock.clockStep = Cesium.ClockStep.SYSTEM_CLOCK_MULTIPLIER;

      // 循环所有坐标数组，并逐渐添加下一个运动点
      car3Arr.forEach((pos) => {
        tempTime_4_car = Cesium.JulianDate.addSeconds(
          tempTime_4_car,
          time_4_car,
          new Cesium.JulianDate()
        );
        property_4_car.addSample(tempTime_4_car, pos);
      });
      car_4.position = property_4_car;
      car_4.orientation = new Cesium.VelocityOrientationProperty(property_4_car);
      entityCache.push(car_4);
    },
    clearEntity() {
      for (var i = 0; i < entityCache.length; i++) {
        viewer.entities.remove(entityCache[i]);
      }
      entityCache = [];
    },
    clear() {
      this.clearEntity();
      point_Start = null;
      point_End = null;
    },
    resetForm(formName) {
      this.clear();
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.item-chaxun {
  display: flex;
  justify-content: center;
  align-items: center;
  // position: absolute;
  // bottom: 20px;
  // left: 0;
  border: 1px solid #ccc;
  padding: 20px;
  width: 100%;
  margin-top: 10px;
}
</style>
<style lang="scss">
.d-pan {
  padding: 0 16px;
  .el-autocomplete {
    position: relative;
    display: inline-block;
    width: 100%;
  }
}
.flightDateClass {
  width: 100% !important;
  .el-range-separator {
    width: 25px !important;
  }
}
</style>
